import { assign } from 'lodash';
import createReducer from './baseReducer';

const conditions = {
  REQUEST_ASSIGN_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_ASSIGN_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  REQUEST_UNASSIGN_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_UNASSIGN_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  REQUEST_DISPATCH_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_DISPATCH_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  REQUEST_BOOKING_STATUS: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_BOOKING_STATUS: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  REQUEST_BOOKING_PAYMENT_STATUS: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_BOOKING_PAYMENT_STATUS: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  REQUEST_RETURN_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_RETURN_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  REQUEST_RESOLVE_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_RESOLVE_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  REQUEST_CANCEL_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: true,
    });
  },
  RECEIVE_CANCEL_BOOKING: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
  RECEIVE_BOOKING_INVOICE: (state, data, error) => {
    return assign({}, state, {
      isFetching: false,
    });
  },
};

export default createReducer('bookings', 'booking', 'bookings', conditions);
